import { ReactNode, useState } from 'react';

import { ProvisionNodesDrawerContext } from './ProvisionNodesDrawerContext';
import {
  ProvisionNodesCloudConfigurationFormValues,
  ProvisionNodesCustomConfigurationFormValues,
} from './types';
import { EnhancedEdgeLocation } from '../../types';

type ProvisionNodesDrawerProviderProps = {
  edgeLocation?: EnhancedEdgeLocation;
  clusterId?: string;
  children: ReactNode;
};

export const ProvisionNodesDrawerProvider = ({
  edgeLocation: initialEdgeLocation,
  clusterId,
  children,
}: ProvisionNodesDrawerProviderProps) => {
  const [selectedEdgeLocation, setSelectedEdgeLocation] =
    useState(initialEdgeLocation);
  const [customConfigValue, setCustomConfigValue] = useState<
    ProvisionNodesCustomConfigurationFormValues | undefined
  >(undefined);
  const [cloudConfigValue, setCloudConfigValue] = useState<
    ProvisionNodesCloudConfigurationFormValues | undefined
  >(undefined);

  // Use the initially provided edge location if available, otherwise use selected
  const edgeLocation = initialEdgeLocation ?? selectedEdgeLocation;

  return (
    <ProvisionNodesDrawerContext.Provider
      value={{
        clusterId,
        edgeLocation,
        hasEdgeLocationPredefined: !!initialEdgeLocation,
        setEdgeLocation: setSelectedEdgeLocation,
        customConfigValue,
        cloudConfigValue,
        setCustomConfigValue,
        setCloudConfigValue,
      }}
    >
      {children}
    </ProvisionNodesDrawerContext.Provider>
  );
};
